import React from 'react';
import styled from 'styled-components';

// Definición de los styled-components
const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem;
  background-color: #f8f9fa; /* Fondo blanco muy suave */
  font-family: 'Inter', sans-serif; /* Tipografía moderna */

  h2 {
    font-size: 1.5rem;
    color: #212529; /* Color oscuro para el título */
    margin-bottom: 3rem;
    font-weight: 500;
    text-align: center;
    border-bottom: 2px solid #007bff; /* Línea de acento */
    padding-bottom: 0.5rem;
  }
`;

const StyledSecciones = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const StyledBox = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem; /* Espaciado entre las tarjetas */
  justify-items: center;
`;

const StyledArticle = styled.article`
  background-color: #ffffff; /* Fondo de la tarjeta */
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08); /* Sombra sutil */
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  max-width: 350px;

  &:hover {
    transform: translateY(-10px); /* Efecto de elevación al pasar el mouse */
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  a {
    text-decoration: none;
    color: inherit;
    display: block;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
`;

const StyledParagraph = styled.p`
  text-align: center;
  font-size: 1.1rem;
  font-weight: 500;
  color: #495057;
  padding: 1rem;
  margin: 0;
`;

// El componente principal
const Secciones = () => {
  return (
    <StyledText>
      <h2>Nuestros clientes</h2>
      <StyledSecciones>
        <section>
          <StyledBox>
              <StyledArticle>
              <a
                href="https://interredestructuras.com.ar/"
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage src="../../img/inter.jpg" alt="Interred Estructuras" />
                <StyledParagraph>Interred Estructuras</StyledParagraph>
              </a>
            </StyledArticle>
            <StyledArticle>
              <a
                href="https://bazar-tech.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage src="../../img/bazar.png" alt="Bazar Tech" />
                <StyledParagraph>Bazar Tech - E-commerce</StyledParagraph>
              </a>
            </StyledArticle>

            <StyledArticle>
              <a
                href="https://soly-luna-casa-de-campo.vercel.app//"
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage src="../../img/SOLY.jpg" alt="Sol y Luna" />
                <StyledParagraph>Casa en Alquiler - Sol y Luna</StyledParagraph>
              </a>
            </StyledArticle>

            <StyledArticle>
              <a
                href="https://marian-sport.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage
                  src="../../img/marian.png"
                  alt="Marian Sport"
                />
                <StyledParagraph>Taller Mecanico - Marian Sport</StyledParagraph>
              </a>
            </StyledArticle>

            <StyledArticle>
              <a
                href="https://c4-g17-m.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage
                  src="../../img/noCountryCinenema.jpg"
                  alt="NC Cinema"
                />
                <StyledParagraph>NC Cinema</StyledParagraph>
              </a>
            </StyledArticle>

            <StyledArticle>
              <a
                href="https://golden-breed.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage src="../../img/petfood.png" alt="Golden Breed" />
                <StyledParagraph>Pet Shop - Food</StyledParagraph>
              </a>
            </StyledArticle>

            <StyledArticle>
              <a
                href="https://planner-pink.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage src="../../img/planner.png" alt="The Planner" />
                <StyledParagraph>Eventos The Planner</StyledParagraph>
              </a>
            </StyledArticle>
          </StyledBox>
        </section>
      </StyledSecciones>
    </StyledText>
  );
};

export default Secciones;